import { optionsObjectToArray } from "@/common/utils/optionsObjectToArray";

export const reportFileTypes = {
  csv: 'CSV',
  xlsx: 'Excel (XLSX)',
};

export const reportFileTypesOptions = optionsObjectToArray(reportFileTypes);
